import { render, staticRenderFns } from "./DocumentTypeTaxonomyForm.vue?vue&type=template&id=072073cd&"
import script from "./DocumentTypeTaxonomyForm.vue?vue&type=script&lang=ts&"
export * from "./DocumentTypeTaxonomyForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports